/* eslint semi: "error" */
/* eslint-disable */
export const getOptionConfig = (barData, category, lang) => {
  let option = {
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '2%',
      right: '6%',
      bottom: '5%',
      top:'13%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLabel: {
        color: "#ffffffd9"
      },

      axisLine: {
        lineStyle: {
          color: '#ffffff1a'
        }
      },
      data: category
    },
    yAxis: {
      type: 'value',
      minInterval: 1,
      axisLine: {
        show: false
      },
      axisLabel: {
        color: "#ffffffd9"
      },
      // 网格样式
      splitLine: {
        show: true,
        lineStyle: {
          color: '#ffffff1a',
          width: 0.5,
          type: 'solid'
        }
      }
    },
    series: [
      {
        name: lang.name,
        type: 'line',
        data: barData,
        symbolSize: 6, //折线点的大小
        itemStyle: {
          normal: {
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(235,127,255,0.43)'// 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(235,127,255,0.03)'// 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            color: 'rgba(235,127,255,1)', // 改变折线点的颜色
            lineStyle: {
              color: 'rgba(235,127,255,1)' // 改变折线颜色
            }
          }
        }
      }
    ]
  };
  return option;
};



// WEBPACK FOOTER //
// ./src/modules/tenantManager/dashboard/newAddedTotal/newDevChar.js